import React from "react";

export default () => {
  return <div>Profile Settings Page</div>;
};
